import React from "react"

import style from "./index.module.sass"

// ----------------------------------------------------------------------------

function sortByName(a, b) {
  if (a.name > b.name) {
    return 1
  }
  if (b.name > a.name) {
    return -1
  }
  return 0
}

function sortByPrice(a, b) {
  if (a.price_cents > b.price_cents) {
    return 1
  }
  if (b.price_cents > a.price_cents) {
    return -1
  }
  return 0
}

export const ORDERING = [
  { title: "name", sortHandler: sortByName },
  { title: "price", sortHandler: sortByPrice },
]

function OrderByList(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const { handleSort, currentSortElement } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  // -------------------------------------

  return (
    <div className={style.container}>
      {ORDERING.map((el, index) => {
        return (
          <div
            key={`ordb-${index}`}
            className={`${style.element} ${
              el.title === currentSortElement?.title ? style.selected : ""
            }`}
            onClick={() => handleSort(el)}
          >
            {I18n.t(`service_ordering.ordering_method.${el.title}`)}
          </div>
        )
      })}
      {!!currentSortElement && (
        <div
          className={style.element}
          onClick={() => handleSort(null)}
        >
          {I18n.t(`service_ordering.ordering_method.reset`)}
        </div>
      )}
    </div>
  )
}

// ----------------------------------------------------------------------------

export default OrderByList
